var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.78037 8.38286C2.48085 8.4241 2.25 8.68465 2.25 8.99992C2.25 9.34385 2.52473 9.62266 2.86364 9.62266H13.65L9.75352 13.561L9.69396 13.6307C9.51522 13.8741 9.53432 14.2201 9.75172 14.4417C9.99087 14.6854 10.3794 14.6862 10.6195 14.4435L15.5608 9.44967C15.5902 9.42106 15.6169 9.3895 15.6402 9.35546C15.8075 9.11228 15.7839 8.77494 15.5695 8.55829L10.6195 3.55645L10.5505 3.4963C10.3099 3.31594 9.96907 3.33678 9.75169 3.55835C9.51256 3.80206 9.5134 4.19636 9.75356 4.43903L13.6509 8.37718H2.86364L2.78037 8.38286Z",
    fill: "#BF5540"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.19e29d41497fc4c344f8029ef9882739.svg";
export { ForwardRef as ReactComponent };